export default "__VITE_ASSET__a1uTXtLs__"